// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__2OhhA","link":"link__2-gH6","section":"section__3CtGK","content":"content__3hnc3","buttons":"buttons__3_1y_"};